module.exports = __webpack_public_path__ + "static/03-d2fd2ac974b0e20b47a5f4036ea9410d.jpg";